import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LogsService } from "./shared/logs.service";

interface LookbackOption {
  label: string;
  value: number;
}

@Component({
  selector: "app-logs",
  templateUrl: "./logs.component.html",
  styleUrls: ["./logs.component.css"],
})
export class LogsComponent implements OnInit {
  form: FormGroup;
  lookbackOptions: LookbackOption[] = [
    { label: "Last 15 minutes", value: 15 },
    { label: "Last 30 minutes", value: 30 },
    { label: "Last 1 hour", value: 60 },
    { label: "Last 3 hours", value: 180 },
    { label: "Last 6 hours", value: 360 },
    { label: "Last 12 hours", value: 720 },
    { label: "Last 24 hours", value: 1440 },
    { label: "Last 3 days", value: 4320 },
    { label: "Last 7 days", value: 10080 },
    { label: "Last 14 days", value: 20160 },
  ];
  columns: string[] = [];
  logs: any[] = [];
  isLoading = false;
  errorMessage: string | null = null;

  constructor(private fb: FormBuilder, private logsService: LogsService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      query: [
        "traces | take 50",
        [Validators.required, Validators.minLength(3)],
      ],
      lookbackMinutes: [60, [Validators.required, Validators.min(1)]],
    });

    this.fetchLogs();
  }

  fetchLogs(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { query, lookbackMinutes } = this.form.value;

    this.isLoading = true;
    this.errorMessage = null;

    this.logsService.getLogs(query, lookbackMinutes).subscribe({
      next: (logs) => {
        this.logs = logs ?? [];
        this.columns = this.logs.length > 0 ? Object.keys(this.logs[0]) : [];
        this.isLoading = false;
      },
      error: (error) => {
        this.errorMessage = typeof error === "string" ? error : "Failed to load logs.";
        this.logs = [];
        this.columns = [];
        this.isLoading = false;
      },
    });
  }

  trackByColumn(_index: number, column: string): string {
    return column;
  }

  trackByRow(index: number): number {
    return index;
  }

  formatValue(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value;
  }
}


